export default __webpack_public_path__ + "static/media/career-timing.cddb307a.png";